<template>
  <v-container>
    <v-row>
      <v-col cols="12" md="6" class="d-flex flex-column justify-center px-8">
        <h2 class="text-h4 font-weight-bold mb-2 text-black">
          Depoimentos de quem já usou a plataforma
        </h2>
        <p class="subtitle-1 text-black">
          Veja o que dizem nossos usuários sobre suas experiências.
          Confiabilidade, praticidade e resultados reais em cada história
          compartilhada.
        </p>
      </v-col>
      <v-col cols="12" md="6">
        <div class="slider">
          <input
            type="radio"
            name="slider"
            title="slide1"
            checked="checked"
            class="slider__nav"
          />
          <input
            type="radio"
            name="slider"
            title="slide2"
            class="slider__nav"
          />
          <input
            type="radio"
            name="slider"
            title="slide3"
            class="slider__nav"
          />
          <div class="slider__inner">
            <div class="slider__contents">
              <img
                alt="Depoimento Fernando Al Alam"
                :src="require('@/assets/testimonials/01.jpg')"
                class="slider__image-avatar"
              />
              <h2 class="slider__caption text-black">Fernando Al Alam</h2>
              <p class="slider__subtitle">
                <a
                  href="https://www.otimizarentaveis.com.br/"
                  target="_blank"
                  style="text-decoration: none; color: gray"
                  >www.otimizarentaveis.com.br</a
                >
              </p>
              <p class="slider__txt">
                “O Maker Market solucionou um problema da minha construtora que
                era a apresentação dos empreendimentos no formato físico, como
                maquete. Agregou muito valor ter um objeto nas negociações para
                apoio ao interessado e a realização foi rápida, dinâmica e de
                ótima qualidade.”
              </p>
            </div>
            <div class="slider__contents">
              <img
                alt="Depoimento Bruno Centurião"
                :src="require('@/assets/testimonials/02.png')"
                class="slider__image-avatar"
              />
              <h2 class="slider__caption text-black">Bruno Centurião</h2>
              <p class="slider__subtitle">
                <a
                  href="https://duoenergy.com.br"
                  target="_blank"
                  style="text-decoration: none; color: gray"
                  >www.duoenergy.com.br</a
                >
              </p>
              <p class="slider__txt">
                “Os chaveiros desenvolvidos pela Maker Market para a DUO Energy
                ficaram excelentes. A qualidade da impressão 3D, o cuidado com
                os acabamentos e o atendimento durante todo o processo
                demonstram o profissionalismo da equipe. Foi uma parceria
                eficiente, com entregas dentro do prazo e um resultado que
                reforça a identidade da nossa marca.”
              </p>
            </div>
            <div class="slider__contents">
              <img
                alt="Depoimento Henrique Almeida"
                :src="require('@/assets/testimonials/03.png')"
                class="slider__image-avatar"
              />
              <h2 class="slider__caption text-black">Henrique Almeida</h2>
              <p class="slider__txt">
                "O Maker Market me trouxe uma demanda de pedidos para imprimir,
                não precisei procurar modelos 3D, falar ou cobrar o comprador.
                Imprimi os produtos indicados pelo Maker Market e depois fui
                pago pelas impressões. Recomendo a todos que buscam ganhar
                dinheiro fazendo impressão 3D e focar apenas na produção,
                deixando todo o trabalho da venda para o pessoal do Maker
                Market."
              </p>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "TestimonialSection",
  data() {
    return {
      intervalId: null,
    };
  },
  mounted() {
    const radios = document.querySelectorAll(".slider__nav");
    let current = 0;

    this.intervalId = setInterval(() => {
      radios[current].checked = false;
      current = (current + 1) % radios.length;
      radios[current].checked = true;
    }, 10000); // troca a cada 10 segundos

    radios.forEach((radio, index) => {
      radio.addEventListener("click", () => {
        clearInterval(this.intervalId);
        current = index;
      });
    });
  },
};
</script>

<style lang="css" scoped>
.testimonial-slider {
  padding: 64px 24px;
}

.slider {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 500px;
}

.slider__subtitle {
  font-size: 12px;
  margin-bottom: 10px;
  margin-top: -20px;
}

.slider__nav {
  width: 12px;
  height: 12px;
  margin: 2rem 12px;
  border-radius: 50%;
  z-index: 10;
  outline: 6px solid #ccc;
  outline-offset: -6px;
  box-shadow: 0 0 0 0 #333;
  cursor: pointer;
  appearance: none;
}

.slider__nav:checked {
  animation: check 0.4s linear forwards;
}

.slider__nav:checked:nth-of-type(1) ~ .slider__inner {
  left: 0%;
}

.slider__nav:checked:nth-of-type(2) ~ .slider__inner {
  left: -100%;
}

.slider__nav:checked:nth-of-type(3) ~ .slider__inner {
  left: -200%;
}

.slider__inner {
  position: absolute;
  top: 0;
  left: 0;
  width: 300%;
  height: 100%;
  transition: left 0.4s;
  display: flex;
}

.slider__contents {
  height: 100%;
  padding: 2rem;
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.slider__image-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid #353738;
}

.slider__caption {
  font-weight: 500;
  margin: 2rem 0 1rem;
  text-transform: uppercase;
}

.slider__txt {
  color: #666;
  margin-bottom: 4rem;
  max-width: 300px;
}

@media screen and (max-width: 959px) {
  .slider {
    height: 550px;
  }
}
@keyframes check {
  50% {
    outline-color: #333;
    box-shadow: 0 0 0 12px #333, 0 0 0 36px rgba(51, 51, 51, 0.2);
  }

  100% {
    outline-color: #333;
    box-shadow: none;
  }
}
</style>
